var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 4.5V19.5C21.375 19.9973 21.1775 20.4742 20.8258 20.8258C20.4742 21.1775 19.9973 21.375 19.5 21.375H4.5C4.00272 21.375 3.52581 21.1775 3.17417 20.8258C2.82254 20.4742 2.625 19.9973 2.625 19.5V4.5C2.625 4.00272 2.82254 3.52581 3.17417 3.17417C3.52581 2.82254 4.00272 2.625 4.5 2.625H19.5C19.9973 2.625 20.4742 2.82254 20.8258 3.17417C21.1775 3.52581 21.375 4.00272 21.375 4.5ZM19.125 4.875H4.875V19.125H19.125V4.875Z",
    fill: "#2C3E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmark);
export default __webpack_public_path__ + "static/media/unmark.95481114487a9ed2ee047e76fd1733d6.svg";
export { ForwardRef as ReactComponent };